export default __webpack_public_path__ + "static/media/alabama.99e869ed.jpg";